import React from 'react'

const InfoNotification = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24ZM12 1.71429C17.6571 1.71429 22.2857 6.34286 22.2857 12C22.2857 17.6571 17.6571 22.2857 12 22.2857C6.34286 22.2857 1.71429 17.6571 1.71429 12C1.71429 6.34286 6.34286 1.71429 12 1.71429Z"
            fill="#B16201"
        />
        <path
            d="M22.2858 12.0001C22.2858 6.34293 17.6572 1.71436 12.0001 1.71436C6.34293 1.71436 1.71436 6.34293 1.71436 12.0001C1.71436 17.6572 6.34293 22.2858 12.0001 22.2858C17.6572 22.2858 22.2858 17.6572 22.2858 12.0001Z"
            fill="white"
        />
        <path
            d="M12.857 16.2856H14.5713V17.9999H9.42847V16.2856H11.1428V11.1428H9.42847V9.42847H12.857V16.2856Z"
            fill="#B16201"
        />
        <path
            d="M12.0001 7.71425C12.6858 7.71425 13.2858 7.11425 13.2858 6.42854C13.2858 5.74282 12.6858 5.14282 12.0001 5.14282C11.3144 5.14282 10.7144 5.74282 10.7144 6.42854C10.7144 7.11425 11.3144 7.71425 12.0001 7.71425Z"
            fill="#B16201"
        />
    </svg>
)

export default InfoNotification
